import React, { useState } from 'react';
import { Box, Checkbox, Typography, IconButton } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { IDocumentItem, TCurrentDocument } from './types';
import { Image } from 'react-feather';
import { AWS_S3 } from 'src/constants/crm/aws';
import { DOCUMENTATION_TITLES } from '../constants';
import { CapitalizeNames } from 'src/utils/capitalize';
import ModalPDF from 'src/components/ModalImage';

interface IDocument {
    title: string;
    file: string;
}

export const DocumentItem = ({
    document,
    mail,
    setMail,
    ...props
}: IDocumentItem) => {
    const { t } = useTranslation();
    const [modalImage, setModalImage] = useState<boolean>(false);
    const [currentDocument, setCurrentDocument] = useState<IDocument>({
        title: '',
        file: '',
    });

    const documents = mail.documents || [];

    const isChecked = documents.some((item) => item.id === document._id);

    const toggleAddDocument = () => {
        let response = [];
        if (isChecked)
            response = documents.filter((item) => item.id !== document._id);
        else {
            const documentToAdd: TCurrentDocument = {
                title: document.title,
                file: AWS_S3 + document.file,
                id: document._id,
            };

            response = [...documents, documentToAdd];
        }

        setMail({ ...mail, documents: response });
    };

    return (
        <Box display="flex" alignItems="center" {...props}>
            <ModalPDF
                title={currentDocument.title}
                source={`https://automotive-api.s3.us-east-2.amazonaws.com/${currentDocument.file}`}
                open={modalImage}
                setOpen={setModalImage}
            />
            <Checkbox checked={isChecked} onClick={toggleAddDocument} />
            <IconButton
                onClick={() => {
                    setCurrentDocument({
                        title:
                            document &&
                            DOCUMENTATION_TITLES.includes(document.title)
                                ? t(`Documents.${document.title}`)
                                : CapitalizeNames(document.title),
                        file: document.file,
                    });
                    setModalImage(true);
                }}
            >
                <Image />
            </IconButton>
            <Typography variant="h6">
                {t(`Documents.${document.title}`)} {document.description}
                {document.vehicle?.model && `(${document.vehicle?.model})`}
            </Typography>
        </Box>
    );
};
